import moment from "moment";
import React, { useState, useEffect } from "react";
import TreeView from "react-bootstrap4-tree";
import axios from "axios";
import { ImFilm, ImVolumeHigh } from "react-icons/im";
import { MdClose, MdFileDownload } from "react-icons/md";
import { Spin } from "antd";
import $ from "jquery";
import Bridge from "../../utils/Bridge";
import { RESEARCH_TYPE } from "../../utils/consts";


const SpeechDataDownload = ({ client_code }) => {
  // const { report } = useStores();
  // const { File } = useStores();
  const [treeData, setTreeData] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  let selectFile = [];

  const mapToNode = (text, customData, showSelect) => {
    return {
      text,
      showSelect,
      state: {
        expanded: false,
        selected: false,
      },
      customData,
      nodes: [],
    };
  };
  useEffect(() => {
    fetchSessionResponse();
  }, []);

  const formatDate = (date) => {
    return moment.utc(date).format("DD-MMM-YYYY HH:MM:SS");
  };
  const fetchSessionResponse = () => {
    setLoading(true);
    let params = `/${client_code}?stat=datadownload`;
    Bridge.personal_data_viewer.get_datadownload_list(params).then((res) => {
      if (res.status == 200) {
        let data = res.data;
        console.log('data download list',data)
        // Convert data to tree structure
        if (data && data.results && data.results.length > 0) {
          // group by date
          let groupByDate = data.results.reduce((acc, current) => {
            let dateLabel = current.date;
            if (dateLabel) {
              let newDate = dateLabel.split("T")[1];
              if (newDate == "00:00:00.000Z") {
                dateLabel = moment(dateLabel.split("T")[0]).format(
                  "DD-MMM-YYYY"
                );
              } else {
                dateLabel = formatDate(current.date);
              }
            }
            let parent = mapToNode(
              dateLabel ? dateLabel : formatDate(current.date),
              { id: current.date },
              false
            );
            if (current.date in acc) {
              parent = acc[current.date];
            }
            let sessionNode = mapToNode(
              current.session_id,
              { id: current.session_id },
              false
            );
            // Get all files
            for (let file of current.files.filter(
              (f) => !f.file_name.includes("patientTurn")
            )) {
              // console.log('file',file)
              // if(RESEARCH_TYPE=='modality.ai'){
              //   if(file.bucket_name=='everythingalsspeech'){

              //   }
              // }else if(RESEARCH_TYPE=='Asymptomatic Study'){
              //   if(file.bucket_name=='everythingalsasymptomatic'){

              //   }
              // }
              sessionNode.nodes.push(mapToNode(getLeafNode(file), file, true));
            }
            parent.nodes.push(sessionNode);
            acc[current.date] = parent;
            return acc;
          }, {});
          let tree = Object.values(groupByDate);
          if (tree) {
            let sortTree = tree.sort((a, b) => moment(b.text) - moment(a.text));
            let lastSession = sortTree[0];
            lastSession.state.expanded = true;
            for (let i = 0; i < lastSession.nodes.length; i++)
              lastSession.nodes[i].state.expanded = true;
            setTreeData(sortTree);
            console.log('sortTree',sortTree)
          }
          setLoading(false)
        }else{
          setLoading(false)
        }
      }
      setLoading(false);
    }).catch((err)=>{
      setLoading(false);
      
    });
  };

  const getLeafNode = (file) => {
    let name = "Session Audio";
    if (file.file_name.includes("mp4")) {
      name = "Session Video";
    }
    return (
      <span>
        {name}
        {file.file_name.includes("mp4") && (
          <ImFilm
            onClick={() => playFile(file)}
            style={{ marginLeft: "5px", fill: "black" }}
          ></ImFilm>
        )}
        {!file.file_name.includes("mp4") && (
          <ImVolumeHigh
            onClick={() => playFile(file)}
            style={{ marginLeft: "5px", fill: "black" }}
          ></ImVolumeHigh>
        )}
        <MdFileDownload
          onClick={() => downloadFile(file)}
          style={{ marginLeft: "5px", fill: "black" }}
        ></MdFileDownload>
      </span>
    );
  };

  const onSelect = (event) => {
    let val = event.state.selected;

    if (val) selectFile.push(event.customData);
    else selectFile = selectFile.filter((e) => e !== event.customData);
  };

  const playFile = async (file) => {
    let response = await createApiHandler(file);
    if (response && response.url) {
      if (file.file_name.includes("mp4")) {
        setVideoUrl(response.url);
        // let video = document.getElementById("data_download_video");
        // video.play();
      } else {
        let audio = new Audio(response.url);
        audio.play();
      }
    }
  };
  const createApiHandler = async (file) => {
    let url=`${process.env.REACT_APP_PATIENT_PORTAL_BASE_URL}file/${file.file_name}`
    let response = await fetch(url,
      {
        method: "POST",
        body: JSON.stringify({
          file_name: file.file_name,
          file_path: file.file_path,
        }),
      }
    );
    return response.json();
  };
  const downloadFile = async (file, index) => {
    let response = await createApiHandler(file);
    if (response && response.url) {
      setTimeout(
        function (file) {
          const link = document.createElement("a");
          link.href = response.url;
          link.id = file.file_name;
          link.target = "_blank";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
        500 * index,
        file
      );
    }
  };
  return (
    <div className={`p-4`}>
      <Spin spinning={loading}>
        <TreeView data={treeData} onSelect={onSelect} />
        {treeData?.length === 0 && (
          <p
            className="text-center"
            style={{
              fontSize: 19,
              textAlign: "center",
              padding: "16px 0px 0px",
            }}
          >
            Not available.
          </p>
        )}
        {videoUrl && (
          <div className={"playerWrapper"}>
            <video
              className={"playerWrapperVideo"}
              id="data_download_video"
              src={videoUrl}
              controls
            ></video>
            <MdClose
              fill="white"
              className={"closeIcon"}
              onClick={() => setVideoUrl(null)}
            ></MdClose>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default SpeechDataDownload;
